import { SocialMediaType } from "@hiptraveler/data-access/api";

export const CSRF_KEY: string = '_ht_social_link_values';

export const MOBILE_SCREEN: number = 900;

export const SOCIAL_URL_PATHS: Record<SocialMediaType, string> = {
  tiktok:    '/trip-planner/tk/oauth',
  twitter:   '/trip-planner/tw/oauth',
  facebook:  '/trip-planner/fb/business/auth',
  instagram: '/trip-planner/insta/auth',
  youtube:   ''
};
